import * as React from "react";
import { memo } from "react";
const SvgCapture = (props) => /* @__PURE__ */ React.createElement("svg", { width: 60, height: 60, viewBox: "0 0 60 60", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 30, cy: 30, r: 24, fill: "currentColor", style: {
  filter: "invert(100%)",
  opacity: 0.5
} }), /* @__PURE__ */ React.createElement("circle", { cx: 30, cy: 30, r: 23, fill: "currentColor" }), /* @__PURE__ */ React.createElement("circle", { cx: 30, cy: 30, r: 28, stroke: "currentColor", strokeWidth: 2, style: {
  filter: "invert(100%)",
  opacity: 0.5
} }), /* @__PURE__ */ React.createElement("circle", { cx: 30, cy: 30, r: 27, stroke: "currentColor", strokeWidth: 2 }));
const Memo = memo(SvgCapture);
export default Memo;
